/**
 * 4–8px Track, animierter Fill.
 * winner=true → Fill in --svo-weiss mit 24px Glow.
 * Skin-aware: dark Track (rgba weiß .08) auf presenter, paper-200 auf light.
 */

interface LiveBarProps {
  value: number;
  max: number;
  winner?: boolean;
  height?: number;
  /** "presenter" | "light" — falls null, nutzt currentColor-Heuristik. */
  skin?: "presenter" | "light";
}

export function LiveBar({ value, max, winner, height = 6, skin }: LiveBarProps) {
  const safeMax = Math.max(1, max);
  const pct = Math.max(0, Math.min(1, value / safeMax));
  const trackBg =
    skin === "light"
      ? "var(--paper-200)"
      : "rgba(255,255,255,0.08)";
  const fillBg = winner ? "var(--svo-weiss, #fff)" : "var(--accent-blue)";
  const glow = winner ? "0 0 24px rgba(255,255,255,0.4)" : "none";

  return (
    <div
      className="beacon-livebar"
      style={{
        position: "relative",
        width: "100%",
        height,
        background: trackBg,
        borderRadius: "var(--r-pill)",
        overflow: "hidden",
      }}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={safeMax}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          width: `${pct * 100}%`,
          background: fillBg,
          boxShadow: glow,
          borderRadius: "var(--r-pill)",
          transition: "width 600ms cubic-bezier(.2,.8,.2,1)",
        }}
      />
    </div>
  );
}
